import {experienceActions} from '../actions';
import * as Date from '../elements/dates/dateHelpers';

export default function experience(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case experienceActions.SET_EXPERIENCE: return setExperienceReducer(newState, action);
        case experienceActions.GENERAL_EXPERIENCE_REQUEST: return setExperienceReducer(newState, action);
        case experienceActions.GENERAL_EXPERIENCE_SUCCESS: return createAndEditReducer(newState, action);
        // case experienceActions.GENERAL_EXPERIENCE_ERROR: return setExperienceReducer(newState, action);
        case experienceActions.DELETE_EXPERIENCE_SUCCESS: return deleteExperienceReducer(newState, action);
        default:
            return newState;
    }
}
// todo /////////////////// why is the if needed below????? alt for object.assign
function setExperienceReducer(newState, action) {
        delete action.type;
        return Object.assign(newState, {...action});
}

function createAndEditReducer(newState, action) {

    const experience = [ ...newState.body  ];

    delete action.type;
    delete action.body.type;

    const itemIndex = experience.find( item => item.id === action.body.id );

    if ( !itemIndex ) {
        experience.push( action.body )
    } else {
        experience[ experience.indexOf( itemIndex ) ] = action.body;
    }

    let orderedArr = Date.orderByDate( experience );

    newState.body = orderedArr;

    return newState;
}

// function createAndEditReducer(newState, action) {
//     delete action.type;
//     delete action.body.type;
//
//     const itemIndex = newState.body.find( item => item.id === action.body.id );
//
//     if ( !itemIndex ) {
//         newState.body.push( action.body )
//     } else {
//         newState.body[ newState.body.indexOf( itemIndex ) ] = action.body;
//     }
//
//     let arrCopy = [...newState.body], orderedArr = Date.orderByDate( arrCopy );
//
//     newState.body = [...orderedArr];
//
//     return newState;
// }

function deleteExperienceReducer(newState, action) {
    delete action.type;
    newState.body = newState.body.filter(e => e.id !== action.body);
    return newState;
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/experience.js